var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeadingTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20V4H12V10H6V4H3V20H6V13H12V20H15Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5146 20H16.6494V18.6328L19.3428 15.208C19.6846 14.734 19.9352 14.3193 20.0947 13.9639C20.2588 13.6038 20.3408 13.2598 20.3408 12.9316C20.3408 12.4896 20.2633 12.1432 20.1084 11.8926C19.958 11.6419 19.7393 11.5166 19.4521 11.5166C19.1377 11.5166 18.887 11.6624 18.7002 11.9541C18.5179 12.2458 18.4268 12.6559 18.4268 13.1846H16.4854C16.4854 12.5739 16.6107 12.0156 16.8613 11.5098C17.1165 11.0039 17.472 10.612 17.9277 10.334C18.388 10.0514 18.9076 9.91016 19.4863 9.91016C20.375 9.91016 21.0632 10.1562 21.5508 10.6484C22.043 11.1361 22.2891 11.8311 22.2891 12.7334C22.2891 13.2939 22.1523 13.8636 21.8789 14.4424C21.61 15.0166 21.1201 15.7253 20.4092 16.5684L19.1309 18.3936H22.5146V20Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadingTwo);
export default __webpack_public_path__ + "static/media/IconHeadingTwo.b88e9aa4.svg";
export { ForwardRef as ReactComponent };